import { Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import { CloudDownload } from '@material-ui/icons';
import { IconButton } from '@roc/ui';
import { observer } from 'mobx-react';
import { Resolution } from '../../types/resolution';
import { ResolutionStore } from '../../stores';
import { TrackRecordResolutionTable } from './trackRecordResolutionTable';

const useStyles = makeStyles(() => ({
  description: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  descriptionContainer: {
    fontSize: '0.9rem',
    display: 'inline-block',
    padding: '1px 0px',
    maxHeight: '250px',
    overflowY: 'auto'
  }
}))

export type ResolutionInfoProps = {
  resolution: Resolution,
  resolutionStore: ResolutionStore,
  showComment?: boolean,
};

export const TrackRecordResolutionInfo = observer(
  (props: ResolutionInfoProps) => {
    const classes = useStyles();
    const { resolution, resolutionStore, showComment = false } = props;

    return (
      <div style={{ marginTop: '0px', paddingTop: '0px' }}>
        {/* <Grid item xs={12}>
          <Divider />
        </Grid> */}
        <Grid item xs={12}>
          {(resolutionStore.canDownloadFile || resolutionStore.canDownloadFileFromInfoScreen) && (
            <Box display="flex" justifyContent="flex-end">
              <IconButton
                type="submit"
                color="primary"
                testId="save"
                onClick={() => (resolutionStore.canDownloadFile ? resolutionStore.downloadDocument() :
                  resolutionStore.downloadDocumentByPath())}
              >
                <CloudDownload />
              </IconButton>
            </Box>
          )}
        </Grid>
        <Grid item xs={12}>
          <Typography
            component="span"
            className={classes.descriptionContainer}
          >
            <Typography component="span" color="textSecondary" className={classes.descriptionContainer}>
              <div>
                Unfortunately we weren't able to verify this property. Please provide supporting proof of ownership.
                <br /><br />
                Below is a list of documents we generally accept to verify, ordered by most supportive to least supportive:
                <br />
                &nbsp;&nbsp;1) Executed HUD/Loan Documents<br />
                &nbsp;&nbsp;2) Entity Filing Documents<br />
                &nbsp;&nbsp;3) EIN Letter<br />
                &nbsp;&nbsp;4) Tax Returns/K-1
              </div>
            </Typography>
            <strong className={classes.description}>{resolution?.itemDescription}</strong>
          </Typography>
        </Grid>
        {/* <Grid item xs={10}>
          <Typography
            component="span"
            style={{ display: 'inline-block', padding: '5px 0px' }}
          >
            <Typography component="span" color="textSecondary">
            </Typography>
            <strong>
              {resolution?.itemName || ''}
            </strong>
          </Typography>
        </Grid> */}
        <Grid item xs={12}>
          <TrackRecordResolutionTable trackRecordData={resolution?.trackRecordData} />
        </Grid>
        {showComment && (
          <Grid item xs={12}>
            <Typography
              component="span"
              style={{ display: 'inline-block', padding: '5px 0px' }}
            >
              <Typography component="span" color="textSecondary">
                Comment:{' '}
              </Typography>
              <strong>{resolution?.comment}</strong>
            </Typography>
          </Grid>
        )}
      </div>
    );
  }
);
